// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.0244 23.9961L9.8291 15.5801L13.9951 11.415L12.5801 10.001L8.41504 14.165L0 9.97168L22.2061 1.79004L14.0244 23.9961Z"}}]};

const Send1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'send-1-filled',
    ref,
    icon: element,
  },
));

Send1FilledIcon.displayName = 'Send1FilledIcon';

export default Send1FilledIcon;
